<!-- recovery-screen.component.html -->
<div class="recovery-wrapper">
  <div class="recovery-content">
    <span class="font-light fs-xlarge text-white recovery-title">
      Estamos recuperando o app...
    </span>

    <p-progressSpinner class="recovery-spinner"></p-progressSpinner>

    <div class="progress-container">
      <p-progressBar [value]="progress" [showValue]="true"></p-progressBar>
    </div>

    <div class="recovery-message">
      <span class="font-light fs-normal text-white">
        <strong>{{ getReasonMessage() }}</strong>
        <br />
        <span *ngIf="recoveryInfo?.details">
          {{ recoveryInfo.details }} <br />
        </span>
        <span *ngIf="getCurrentStep()" class="current-step">
          {{ getCurrentStep() }} <br />
        </span>
        Vamos inicializar o processo de recuperação, isso pode levar apenas
        alguns segundos 🛠️
      </span>
    </div>

    <div *ngIf="getLastRecovery()" class="last-recovery">
      <small class="text-white-alpha-70">
        {{ getLastRecovery() }}
      </small>
    </div>

    <div class="actions" *ngIf="showCancelButton">
      <button
        pButton
        label="Continuar para o App"
        icon="pi pi-arrow-right"
        class="p-button-outlined p-button-rounded p-button-white"
        (click)="forceFinish()"
      ></button>
    </div>
  </div>
</div>
